import { Component } from '@angular/core';

@Component({
  selector: 'greco-cart',
  templateUrl: './cart.page.html',
  styleUrls: ['./cart.page.scss'],
})
export class CartPage {}
